import noop from './noop.js';

const { default: closeWindowOffer } = IS_CLIENT ? await import('#frontend/util/closeWindowOffer.js') : {};

/**
 * Export the Vue plugin install method
 * @param {object} Vue Vue instance
 */
export const install = (Vue) => {
	Vue.prototype.closeWindowOffer = {
		set: closeWindowOffer?.set ?? noop,
		unset: closeWindowOffer?.unset ?? noop
	};
};

export default {
	install
};
